/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Input View container for the app  
Author: Deimos Space UK

Version: 1.0
*/
import React, { useState, useEffect } from 'react'
import MissionDefinition from '../components/MissionDefinition/MissionDefinition'
import MissionOperation from '../components/MissionOperation/MissionOperation'
import MissionPhases from '../components/MissionPhases/MissionPhases'
import PMDphases from '../components/PMDphases/PMDphases'
import { Col, Row, Card, CardBody } from "reactstrap";
import { Stepper, Step } from 'react-form-stepper';
import { useParams } from 'react-router-dom'
import { getPetition } from "../../../api/api";
import db from '../../../utils/db/db'
import Spinner from 'react-bootstrap/Spinner';

const stepsArray = [MissionDefinition, MissionOperation, MissionPhases, PMDphases]
const InputView = () => {
    const [step, setStep] = useState(0)
    const [loading, setLoading] = useState(false)
    const [architectureType, setArchitectureType] = useState('')

    const handleNext = () => {
        setStep(step + 1)
    }
    const handleBack = () => {
        setStep(step - 1)
    }
    const handleReset = () => {
        setStep(0)
    }
    const Component = stepsArray[step]

    const navigateToStep = (step) => {
        setStep(step)
    }
    const setFormDarta = (form) => {
        if (form && form.mission && form.mission.architecture === 'single') {
            setArchitectureType('single')
            setSingleMision(form)
        }
        else if (form && form.mission && form.mission.architecture === 'carrier') {
            setArchitectureType('carrier')
            setCarrierMision(form)
        } else if (form && form.mission && form.mission.architecture === 'launcher') {
            setArchitectureType('launcher')
            setLauncherMission(form)
        } else if (form && form.mission && form.mission.architecture === 'constellation') {
            setArchitectureType('constellation')
            setConstellationMission(form)
        }

    }
    const transformDate = (date) => {
        
        const newDate = new Date(date);
        const year = newDate.getFullYear();
        let month = newDate.getMonth() + 1;
        let day = newDate.getDate();
        if (month < 10) {
            month = "0" + month;
        }
        if (day < 10) {
            day = "0" + day;
        }
        const formattedDate = year + "-" + month + "-" + day;
        return formattedDate;
    }
   

    const getAssociatedTo = (value) => {
        const associatedTo = []
        if (value && value.length > 0) {
            value.forEach((item) => {
                associatedTo.push({
                    weighted_value: item.weighted_value.toString(),
                    spacecraft_id: item.spacecraft_id.toString(),
                })
            })
        }else{
            associatedTo.push({
                weighted_value: '',
                spacecraft_id: '',
            })
        }
        return associatedTo
    }

    const setLauncherMission = (form) => {
        setLoading(true)
        const firstStep = {
            architectureType: form.mission?.architecture,
            missions: form.mission?.name,
            version: form.mission?.version,
            type: {
                value: form.mission?.type,
                label: form.mission?.type
            },
            satellitesPerOrbit: 0,
            associatedTo: getAssociatedTo(form.space_vehicle?.associated_to),
        }      
        sessionStorage.setItem('firstStep', JSON.stringify(firstStep))
        const secondStep = [{
            SpacecraftDesign: {
                mass: form.space_vehicle?.mass,
                cross: form.space_vehicle?.acs,
                objectType: {
                    value: form.space_vehicle?.object_type,
                    label: form.space_vehicle?.object_type
                },
            },

            MissionOperation: {
                camStatus: form.space_vehicle?.active ? 'active' : 'not-active',
                debrisTrackability: form.space_vehicle?.debris_trackability,

            },


        }]

        sessionStorage.setItem('secondStep', JSON.stringify(secondStep))
       setFourthStep(form.space_vehicle?.phases.launch)

    }

    const setCarrierMision = (form) => {
        setLoading(true)
        const firstStep = {
            architectureType: form.mission?.architecture,
            missions: form.mission?.name,
            version: form.mission?.version,
            type: {
                value: form.mission?.type,
                label: form.mission?.type
            },
            satellitesPerOrbit: 0,
            associatedTo: getAssociatedTo(form.space_vehicle?.associated_to),
        }
        sessionStorage.setItem('firstStep', JSON.stringify(firstStep))
        const secondStep = [{
            SpacecraftDesign: {
                mass: form.space_vehicle?.mass,
                cross: form.space_vehicle?.acs,
                objectType: {
                    value: form.space_vehicle?.object_type,
                    label: form.space_vehicle?.object_type
                },
            },

            MissionOperation: {
                cam: form.space_vehicle?.cam ? 'yes' : 'no',
                camStatus: form.space_vehicle?.active ? 'active' : 'not-active',
                debrisTrackability: form.space_vehicle?.debris_trackability,
                acpl: form.space_vehicle?.acpl,
                cam_efficacy: form.space_vehicle?.cam_efficacy,
                pmdSuccessRate: form.space_vehicle?.pmd_reliability,
            },
            PropulsionTechnology: {
                propulsionTechnology: {
                    value: form.space_vehicle.propulsion?.type,
                    label: form.space_vehicle.propulsion?.type
                },
                specificImpulse: form.space_vehicle.propulsion?.isp,
                maximumThrust: form.space_vehicle.propulsion?.thrust,
                thrustLifetime: form.space_vehicle.propulsion?.lifetime,
                mass: form.space_vehicle.propulsion?.mass,
                effectiveSailArea: form.space_vehicle.propulsion?.acs,
                propulsionTechnologySubtype: {
                    value: form.space_vehicle.propulsion?.technology,
                    label: form.space_vehicle.propulsion?.technology
                },
            }

        }]
        sessionStorage.setItem('secondStep', JSON.stringify(secondStep))
        const thirdStep = [{
            launchPhase: getPhase(form.space_vehicle.phases.launch, 'launch'),
            operationalOribitInjectionPhase: getPhase(form.space_vehicle.phases.injection, 'injection'),
            operationalPhase: getPhase(form.space_vehicle.phases.operational, 'operational'),
        }]
        sessionStorage.setItem('thirdStep', JSON.stringify(thirdStep))
        setFourthStep(form.space_vehicle?.phases.pmd)
        setLoading(false)
    }

    const setSingleMision = (form) => {
        setLoading(true)
        const firstStep = {
            architectureType: form.mission?.architecture,
            missions: form.mission?.name,
            version: form.mission?.version,
            type: {
                value: form.mission?.type,
                label: form.mission?.type
            },
            satellitesPerOrbit: 0,
            associatedTo: [{
                indexShare: '',
                associatedTo: '',
            }]
        }

        sessionStorage.setItem('firstStep', JSON.stringify(firstStep))
        const secondStep = [{
            SpacecraftDesign: {
                mass: form.space_vehicle?.mass,
                cross: form.space_vehicle?.acs,
                objectType: {
                    value: form.space_vehicle?.object_type,
                    label: form.space_vehicle?.object_type
                },
            },

            MissionOperation: {
                cam: form.space_vehicle?.cam ? 'yes' : 'no',
                camStatus: form.space_vehicle?.active ? 'active' : 'not-active',
                debrisTrackability: form.space_vehicle?.debris_trackability,
                acpl: form.space_vehicle?.acpl,
                cam_efficacy: form.space_vehicle?.cam_efficacy,
                pmdSuccessRate: form.space_vehicle?.pmd_reliability,
            },
            PropulsionTechnology: {
                propulsionTechnology: {
                    value: form.space_vehicle.propulsion?.type,
                    label: form.space_vehicle.propulsion?.type
                },
                specificImpulse: form.space_vehicle.propulsion?.isp,
                maximumThrust: form.space_vehicle.propulsion?.thrust,
                thrustLifetime: form.space_vehicle.propulsion?.lifetime,
                mass: form.space_vehicle.propulsion?.mass,
                effectiveSailArea: form.space_vehicle.propulsion?.acs,
                propulsionTechnologySubtype: {
                    value: form.space_vehicle.propulsion?.technology,
                    label: form.space_vehicle.propulsion?.technology
                },
            }

        }]

        sessionStorage.setItem('secondStep', JSON.stringify(secondStep))
        const thirdStep = [{
            launchPhase: getPhase(form.space_vehicle.phases.launch, 'launch'),
            operationalOribitInjectionPhase: getPhase(form.space_vehicle.phases.injection, 'injection'),
            operationalPhase: getPhase(form.space_vehicle.phases.operational, 'operational'),
        }]
        sessionStorage.setItem('thirdStep', JSON.stringify(thirdStep))

        setFourthStep(form.space_vehicle?.phases.pmd)
        setLoading(false)
    }
    const setFourthStep = (form) => {
        const fourthStep = {
            semiMajorAxis: form[0]?.keplerian.sma,
            eccentricity: form[0]?.keplerian.eccentricity,
            inclination: form[0]?.keplerian.inclination,
            rightAscension: form[0]?.keplerian.raan,
            argumentOfPerigee: form[0]?.keplerian.argument_perigee,
            meanAnomaly: form[0]?.keplerian.mean_anomaly,
            targetedDeorbit: false,
            directDisposal: false,
            reorbit: false,
            noDisposal: false,
            directDisposalData: {
                targetPerigee: '',
            },
            targetedDeorbitData: {
                disposalSystem: '',
                hohmannTransfer: '',
                lifetimeLimit: '',
                crossSection: '',
                dragCoefficient: '',
                reflectivityCoefficient: '',
            },
            reorbitData: {
                disposalSystem: '',
                hohmannTransfer: '',
                reorbitAltitude: '',
            },
        }
        form.forEach((phase, index) => {

            if (phase.type === 'oscar' && !fourthStep.startEpoch) {
                fourthStep.startEpoch = transformDate(phase.disposal_option?.start_epoch)
                fourthStep.crossSection = phase.disposal_option?.acs
                fourthStep.dragCoefficient = phase.disposal_option?.drag_coefficient
                fourthStep.reflectivityCoefficient = phase.disposal_option?.reflectivity_coefficient
            }
            if (phase.disposal_option.type === 'direct_disposal') {
                fourthStep.directDisposal = true
                fourthStep.directDisposalData = {
                    targetPerigee: phase.disposal_option?.target_perigee,
                }
            }
            if (phase.disposal_option.type === 'targeted_disposal') {
                fourthStep.targetedDeorbit = true
                fourthStep.targetedDeorbitData = {
                    disposalSystem: {
                        value: phase.disposal_option?.disposal_system,
                        label: phase.disposal_option?.disposal_system
                    },
                    hohmannTransfer: phase.disposal_option?.hohmann,
                    lifetimeLimit: phase.disposal_option?.lifetime_limit,
                    crossSection: phase.disposal_option?.dad_acs,
                    dragCoefficient: phase.disposal_option?.dad_drag_coefficient,
                    reflectivityCoefficient: phase.disposal_option?.dad_reflectivity_coefficient,
                }
            }
            if (phase.disposal_option.type === 'reorbit_disposal') {
                fourthStep.reorbit = true
                fourthStep.reorbitData = {
                    disposalSystem: {
                        value: phase.disposal_option?.disposal_system,
                        label: phase.disposal_option?.disposal_system
                    },
                    hohmannTransfer: phase.disposal_option?.hohmann,
                    reorbitAltitude: phase.disposal_option?.altitude,
                }
            }
            if (phase.disposal_option.type === 'no_disposal') {
                fourthStep.noDisposal = true
            }
        })
        sessionStorage.setItem('fourthStep', JSON.stringify(fourthStep))

    }

    const setConstellationMission = (form) => {
        setLoading(true)
        const firstStep = {
            architectureType: form.mission?.architecture,
            missions: form.mission?.name,
            version: form.mission?.version,
            constellationName: form.mission?.constellation_name,
            type: {
                value: form.mission?.type,
                label: form.mission?.type
            },
            nOrbits: form.space_vehicle?.spacecrafts.length,
            satellitesPerOrbit: [
                {
                    id: 0,
                }
            ],
            associatedTo: [{
                indexShare: '',
                associatedTo: '',
            }]
        }
        sessionStorage.setItem('firstStep', JSON.stringify(firstStep))
        setSecondStepConstellation(form.space_vehicle.spacecrafts)
        setStepThreeConstellation(form.space_vehicle.spacecrafts)
        setFourthStep(form.space_vehicle?.spacecrafts[0].phases.pmd)

    }
    const setSecondStepConstellation = (form) => {
        const secondStepOrbits = []
        form.forEach((element, index) => {
            const secondStep = {
                SpacecraftDesign: {
                    mass: element?.mass,
                    cross: element?.acs,
                    objectType: {
                        value: element?.object_type,
                        label: element?.object_type
                    },
                },

                MissionOperation: {
                    cam: element?.cam ? 'yes' : 'no',
                    camStatus: element?.active ? 'active' : 'not-active',
                    debrisTrackability: element?.debris_trackability,
                    acpl: element?.acpl,
                    cam_efficacy: element?.cam_efficacy,
                    pmdSuccessRate: element?.pmd_reliability,
                },
                PropulsionTechnology: {
                    propulsionTechnology: {
                        value: element.propulsion?.type,
                        label: element.propulsion?.type
                    },
                    specificImpulse: element.propulsion?.isp,
                    maximumThrust: element.propulsion?.thrust,
                    thrustLifetime: element.propulsion?.lifetime,
                    mass: element.propulsion?.mass,
                    effectiveSailArea: element.propulsion?.acs,
                    propulsionTechnologySubtype: {
                        value: element.propulsion?.technology,
                        label: element.propulsion?.technology
                    },
                }

            }
            secondStepOrbits.push(secondStep)
        }
        )
        sessionStorage.setItem('secondStep', JSON.stringify(secondStepOrbits))
    }
    const setStepThreeConstellation = (form) => {
        const thirdStepOrbits = []
        const constellationFourthStep = []
        
        form.forEach((element, index) => {
            const thirdStep = {
                launchPhase: getPhase(element.phases.launch, 'launch'),
                operationalOribitInjectionPhase: getPhase(element.phases.injection, 'injection'),
                operationalPhase: getPhase(element.phases.operational, 'operational'),
            }
            thirdStepOrbits.push(thirdStep)
            constellationFourthStep.push({
                    semiMajorAxis: element.phases.pmd[0]?.keplerian.sma,
                    eccentricity: element.phases.pmd[0]?.keplerian.eccentricity,
                    inclination: element.phases.pmd[0]?.keplerian.inclination,
                    rightAscension: element.phases.pmd[0]?.keplerian.raan,
                    argumentOfPerigee: element.phases.pmd[0]?.keplerian.argument_perigee,
                    meanAnomaly: element.phases.pmd[0]?.keplerian.mean_anomaly,
                    crossSection: element.phases.pmd[0]?.disposal_option.acs,
                    reflectivityCoefficient: element.phases.pmd[0]?.disposal_option.reflectivity_coefficient,
                    dragCoefficient: element.phases.pmd[0]?.disposal_option.drag_coefficient,
                    startEpoch: transformDate(element.phases.pmd[0]?.disposal_option.start_epoch),
                
            })
        }
        )
        sessionStorage.setItem('thirdStep', JSON.stringify(thirdStepOrbits))
        sessionStorage.setItem('fourthStepConstellation', JSON.stringify(constellationFourthStep))
    }

    const getPhase = (form, phase) => {
        const spacecraft_phase = []
        form.forEach((element) => {
            let orbit
            if (element.type === 'file') {
                orbit = {
                    data: element.orbit_type.phase_id,
                    type: 'file'
                }

            } else {
                orbit = {
                    type: 'base',
                    start_epoch: transformDate(element?.start_epoch),
                    end_epoch: transformDate(element?.end_epoch),
                    keplerian: {
                        raan: element.keplerian?.raan,
                        sma: element?.keplerian?.sma,
                        eccentricity: element?.keplerian?.eccentricity,
                        mean_anomaly: element?.keplerian?.mean_anomaly,
                        argument_perigee: element?.keplerian?.argument_perigee,
                        inclination: element?.keplerian?.inclination,
                    }
                }
            }
            spacecraft_phase.push(orbit)

        });
        return spacecraft_phase
    }
    const { id } = useParams();

    useEffect(() => {

        setLoading(true)
        if (!id) {
            const user = JSON.parse(sessionStorage.getItem('user'))
                  sessionStorage.clear()
                  sessionStorage.setItem('user', JSON.stringify(user))
            db.files.clear();
            setLoading(false)
        }
    }, [id])



    useEffect(() => {

        if (id) {
            setLoading(true)
            getPetition(`/api/mission/entire_mission?mission_id=${id}`)
                .then((data) => {
                    setFormDarta(data)
                    setLoading(false)
                })
                .catch((error) => {
                    setLoading(false)
                })
        }
        return () => {
            const user = JSON.parse(sessionStorage.getItem('user'))
            sessionStorage.clear()
            sessionStorage.setItem('user', JSON.stringify(user))
            db.files.clear();
        }
    }, [id])

    if (loading) {
        return <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
            <Spinner animation="border" />
        </div>
    }

    return (
        <div style={{ width: '100%', height: 'auto', display: 'flex', flexDirection: 'column', }}>
            {
                !id && <Row>
                    <Col xs={12}>
                        <h3 style={{ color: '#003247' }}>Environmental impact evaluation</h3>
                    </Col>
                </Row>
            }

            <Row>
                <Col xs={12}>
                    <Stepper activeStep={step} styleConfig={{ activeBgColor: '#003247', completedBgColor: '#002839' }}>
                        <Step onClick={() => navigateToStep(0)} label='Mission architecture' />
                        <Step onClick={() => navigateToStep(1)} label="Mission parameters" />
                        <Step onClick={() => navigateToStep(2)} label="Mission phases" />
                        {(architectureType.value !== 'launcher' && architectureType !== 'launcher') &&
                            <Step onClick={() => navigateToStep(3)} label="PMD phase" />
                        }

                    </Stepper>

                </Col>
            </Row>
            <Row style={{ width: '100%' }}>
                <Col xs={12}>
                    <Card className="widget-flat" style={{ width: '100%', marginLeft: '10%', justifyContent: 'center', margin: 0, alignContent: 'center', alignSelf: 'center' }}>
                        <CardBody style={{ overflowY: 'auto', width: '100%', justifySelf: 'center', display: 'flex', alignSelf: 'center', }} >

                            <Component
                                id={id}
                                handleNext={handleNext}
                                handleBack={handleBack}
                                handleReset={handleReset}
                                checkArchitecture={setArchitectureType}
                                step={step}
                                loading={loading}
                            />

                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <div style={{
                justifyContent: 'space-between',
                alignContent: 'center',
                paddingTop: '20px', paddingBottom: '20px'
            }}>
                <span style={{ alignSelf: 'center', color: '#003247' }}>Step {step + 1} of {(architectureType.value !== 'launcher' && architectureType !== 'launcher') ? '4' : '3'}</span>

            </div>
        </div>
    )

}

export default InputView